<!--开票点管理-->
<template>
  <div class="coal-rule-wrap">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/cargo/type' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>资料管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>开票点管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-row mt-0">
        <div class="toolbar-item" id="auto-0">
          <el-button type="primary" size="small" @click="operateTicket('add')">新增开票点</el-button>
        </div>
      </div>
    </div>
    <div class="table-custom-box" id="auto-1">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <template #handle="{ scope }">
          <el-button type="text" class="font-size12" @click="operateTicket('edit', scope.row)">查看</el-button>
          <el-button type="text" class="font-size12" @click="del(scope.row)">删除</el-button>
        </template>
      </fe-table>
    </div>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:1
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */

import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import tableMixin from '@/utils/tableMixin';
export default {
  mixins: [tableMixin],
  data() {
    return {
      columns: [
        { label: '开票点名称', prop: 'positionName', 'min-width': 100 },
        { label: '开票员人数', prop: 'memberCount', 'min-width': 100 },
        { label: '操作', prop: 'handle', 'min-width': 100 }
      ],
      tableOptions: {},
      axiosConfig: { url: api.queryTicketPositionList }
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    operateTicket(type, item = {}) {
      if (type === 'edit') {
        this.$router.push({ name: 'ticketedPointAdd', query: { ticketId: item.id } });
      } else {
        this.$router.push({ path: '/ticketedPointAdd' });
      }
    },
    del(item) {
      this.$confirm('是否删除该开票点?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await axios.post(api.deleteTicketPosition, { id: item.id });
          this.$message.success('删除成功');
          this.handleSearch();
        })
        .catch(() => {});
    }
  }
};
</script>
